import { api } from './api'

const buildPayload = (serviceData, companyId) => ({
  ...serviceData,
  name: serviceData.name.trim(),
  description: serviceData.description ? serviceData.description.trim() : '',
  duration: serviceData.duration === '' || serviceData.duration == null ? null : Number(serviceData.duration),
  price: serviceData.price === '' || serviceData.price == null ? null : Number(serviceData.price),
  ...(companyId != null && { company_id: String(companyId) })
})

export const servicesService = {
  /*Obtiene todos los servicios. tenantId: empresa distinta a la activa (ver api.js get()).*/
  async getAll(tenantId) {
    try {
      const response = await api.get('/services', true, tenantId ? { tenantId } : {})
      return response
    } catch (error) {
      console.error('Error obteniendo servicios:', error)
      throw error
    }
  },

  /*Obtiene un servicio por su ID*/
  async getById(serviceId) {
    try {
      const response = await api.get(`/services/${serviceId}`, true)
      return response
    } catch (error) {
      console.error('Error obteniendo servicio:', error)
      throw error
    }
  },

  /*Crea un nuevo servicio. tenantId: empresa distinta a la activa (ver api.js post()).*/
  async create(companyId, serviceData, tenantId) {
    try {
      const payload = buildPayload(serviceData, companyId)

      const response = await api.post('/services', payload, true, tenantId ? { tenantId } : {})
      return response
    } catch (error) {
      console.error('Error creando servicio:', error)
      console.error('Status:', error.status)
      console.error('Data:', JSON.stringify(error.data, null, 2))
      throw error
    }
  },

  /*Actualiza un servicio existente. tenantId: empresa distinta a la activa (ver api.js put()).*/
  async update(serviceId, companyId, serviceData, tenantId) {
    try {
      const payload = buildPayload(serviceData, companyId)

      const response = await api.put(`/services/${serviceId}`, payload, true, tenantId ? { tenantId } : {})
      return response
    } catch (error) {
      console.error('Error actualizando servicio:', error)
      throw error
    }
  },

  async deactivate(serviceId) {
    try {
      const response = await api.patch(`/services/${serviceId}/deactivate`, {}, true)
      return response
    } catch (error) {
      console.error('Error pausando servicio:', error)
      throw error
    }
  },

  async reactivate(serviceId) {
    try {
      const response = await api.patch(`/services/${serviceId}/reactivate`, {}, true)
      return response
    } catch (error) {
      console.error('Error reactivando servicio:', error)
      throw error
    }
  },

  /*Elimina un servicio*/
  async delete(serviceId) {
    try {
      const response = await api.delete(`/services/${serviceId}`, true)
      return response
    } catch (error) {
      console.error('Error eliminando servicio:', error)
      throw error
    }
  }
}
